import { Action, createReducer, on } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { Order } from '@rd/types/order.type';
import { IntentionalUndefined } from 'global-types';
import {
  CheckoutOrder,
  CheckoutOrderFail,
  CheckoutOrderSuccess,
} from '../actions/order-checkout.actions';

export interface CheckoutOrderState {
  error: HttpError | null;
  loading: boolean;
}

const initialState: CheckoutOrderState = {
  error: null,
  loading: false,
};

const featureReducer = createReducer(
  initialState,
  on(CheckoutOrder, (state: CheckoutOrderState) => {
    return {
      ...state,
      error: null,
      loading: true,
    };
  }),
  on(CheckoutOrderFail, (state: CheckoutOrderState, payload: HttpError) => {
    const { ...httpError } = payload;
    return {
      ...state,
      error: httpError,
      loading: false,
    };
  }),
  on(
    CheckoutOrderSuccess,
    (
      state: CheckoutOrderState,
      payload: {
        order: Order;
      },
    ) => {
      return {
        ...state,
        error: null,
        loading: false,
      };
    },
  ),
);

export function checkoutOrderReducer(
  state: CheckoutOrderState | IntentionalUndefined,
  action: Action,
): CheckoutOrderState {
  return featureReducer(state, action);
}
